<template>
  <div class="pa-6 bg-custom">
    <!-- ถ้าเปิดใช้งานฟีเจอร์ให้เอา comment ออก (1)-->
    <!-- <h2 class="mb-4">
      {{ $vuetify.lang.t('$vuetify.courseManagement.stepCourse.bundle') }}
    </h2> -->

    <v-sheet color="white" class="mb-6 pa-6">
      <v-row no-gutters>
        <v-col cols="12">
          <div align="center">
            <h2 class="red--text">
              {{ $vuetify.lang.t('$vuetify.courseManagement.bundle.betaMsg') }}
            </h2>
          </div>

          <!-- ถ้าเปิดใช้งานฟีเจอร์ให้เอา comment ออก (2)-->
          <!-- <p class="mb-3 body-1 font-weight-medium text-custom-title">
            {{
              $vuetify.lang.t('$vuetify.courseManagement.bundle.bundleOption')
            }}
            <span class="red--text">*</span>
          </p>
          <p class="mb-0 body-2 font-weight-light grey--text">
            {{ $vuetify.lang.t('$vuetify.courseManagement.bundle.optionMsg1') }}
          </p>
          <p class="body-2 font-weight-light grey--text">
            {{ $vuetify.lang.t('$vuetify.courseManagement.bundle.optionMsg2') }}
          </p> -->
        </v-col>
      </v-row>
      <!-- ถ้าเปิดใช้งานฟีเจอร์ให้เอา comment ออก (3)-->
      <!-- <v-row no-gutters>
        <v-radio-group
          class="mt-0 pa-0"
          v-model="bundleOption"
          row
          @change="updatePricingOption"
          hide-details=""
        >
          <v-radio
            :label="
              $vuetify.lang.t('$vuetify.courseManagement.bundle.optionNo')
            "
            :value="false"
          ></v-radio>
          <v-radio
            :label="
              $vuetify.lang.t('$vuetify.courseManagement.bundle.optionYes')
            "
            :value="true"
          ></v-radio>
        </v-radio-group>

        <div class="body-1 orange--text" v-show="pricingOptionSaving">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.whoCanSeeStep.savingSetting'
            )
          }}
        </div>
        <div class="body-1 green--text" v-show="pricingOptionSuccess">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.whoCanSeeStep.savingSettingSuccess'
            )
          }}
        </div>
        <div class="body-1 red--text" v-show="pricingOptionFail">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.whoCanSeeStep.savingSettingFail'
            )
          }}
        </div>
      </v-row> -->
    </v-sheet>

    <!-- ถ้าเปิดใช้งานฟีเจอร์ให้เอา comment ออก (4)-->
    <!-- <v-sheet color="white" class="mb-6 pa-6" v-if="bundleOption == true">
      <v-row no-gutters>
        <v-col lg="11" cols="11">
          <div
            class="
              body-1
              font-weight-medium
              text-custom-title
              mb-4
              d-flex
              align-center
            "
          >
            <v-icon color="info" class="mr-2">mdi-information-outline</v-icon>
            {{ $vuetify.lang.t('$vuetify.courseManagement.bundle.info1') }}
          </div>
          <p class="body-2">
            {{ $vuetify.lang.t('$vuetify.courseManagement.bundle.info2') }}
          </p>
          <p class="body-2 mb-0">
            {{ $vuetify.lang.t('$vuetify.courseManagement.bundle.info3') }}
          </p>
        </v-col>
      </v-row>
    </v-sheet> -->

    <!-- ถ้าเปิดใช้งานฟีเจอร์ให้เอา comment ออก (5)-->
    <!-- <div v-if="bundleOption == true">
      <v-row no-gutters class="mb-6">
        <v-col cols="12">
          <v-card-actions class="pa-0">
            <v-spacer></v-spacer>
            <v-btn
              @click="openDialogAddBundle(null)"
              elevation="0"
              class="
                pl-5
                pr-5
                xs-full-width
                font-weight-light
                button-primary
                white--text
              "
            >
              <v-icon left>mdi-plus</v-icon>
              {{
                $vuetify.lang.t('$vuetify.courseManagement.filterBar.addBundle')
              }}
            </v-btn>
          </v-card-actions>
        </v-col>
      </v-row>

      <v-row no-gutters class="mb-6">
        <v-col cols="12">
          <v-sheet color="white" class="pa-2">
            <v-row class="px-4">
              <v-col cols="12" sm="6" md="4" class="mt-auto">
                <p class="caption mb-0">
                  {{
                    $vuetify.lang.t('$vuetify.courseManagement.bundle.status')
                  }}
                </p>
                <v-btn-toggle
                  class="mb-0"
                  color="primary accent-3"
                  background-color="white"
                  mandatory
                  v-model="status_toggle"
                  @change="applyFilter"
                >
                  <v-btn class="text-capitalize body-2" height="40px">{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.bundle.statusAll'
                    )
                  }}</v-btn>
                  <v-btn class="text-capitalize body-2" height="40px"
                    >{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.bundle.statusOn'
                      )
                    }}
                  </v-btn>
                  <v-btn class="text-capitalize body-2" height="40px">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.bundle.statusOff'
                      )
                    }}
                  </v-btn>
                </v-btn-toggle>
              </v-col>
              <v-spacer></v-spacer>
              <v-col
                cols="12"
                sm="6"
                md="2"
                class="mt-auto"
                style="display: flex; justify-content: flex-end"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      btn-reload
                      @click="initialize"
                      class="
                        ml-5
                        pl-5
                        pr-5
                        xs-full-width
                        font-weight-light
                        body-2
                        text-capitalize
                        mt-0
                        btn-reload
                      "
                      height="40px"
                    >
                      <v-icon>mdi-cached</v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.filterBar.refresh'
                    )
                  }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>

      <v-row no-gutters class="mb-6">
        <v-col cols="12">
          <v-data-table
            :loading="loading"
            :headers="headerTable"
            hide-default-footer
            :items="arrBundles"
            class="font-weight-light"
            elevation="0"
          >
            <template v-slot:item.images="{ item }">
              <v-img
                :src="item.images == null ? imageReady : item.images"
                class="my-3 ml-auto mr-auto rounded-card img-md"
                aspect-ratio="1"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-icon
                      v-if="imageReady"
                      class="mx-auto"
                      elevation="3"
                      size="60"
                      >mdi-image</v-icon
                    >
                  </v-row>
                </template>
              </v-img>
            </template>
            <template v-slot:item.price="{ item }">
              {{
                item.price == 0
                  ? 'Free'
                  : Number(item.price).toLocaleString() + ' Baht'
              }}
            </template>
            

            <template v-slot:item.startTime="{ item }">
              {{ item.startTime | moment('DD/MM/YYYY') }}&nbsp;
              {{ new Date(item.startTime).toString().substr(16, 2) + ':'
              }}{{ new Date(item.startTime).toString().substr(19, 2) }}
            </template>
            <template v-slot:item.endTime="{ item }">
              {{ item.endTime | moment('DD/MM/YYYY') }}&nbsp;
              {{ new Date(item.endTime).toString().substr(16, 2) + ':'
              }}{{ new Date(item.endTime).toString().substr(19, 2) }}
            </template>
            <template v-slot:item.groups="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-if="item.groups.length <= 1"
                    class="
                      text-capitalize
                      button-secondary
                      body-2
                      font-weight-light
                    "
                    small
                    elevation="0"
                    v-on="on"
                    @click="getUserGroup(item)"
                    >{{ item.groups.length }} Group</v-btn
                  >
                  <v-btn
                    v-if="item.groups.length > 1"
                    class="
                      text-capitalize
                      button-secondary
                      body-2
                      font-weight-light
                    "
                    small
                    elevation="0"
                    v-on="on"
                    @click="getUserGroup(item)"
                    >{{ item.groups.length }} Groups</v-btn
                  >
                </template>
                <div class="text-center">
                  <span class="subtitle-1 mx-2">CLICK TO EDIT GROUPS:</span>
                </div>
                <v-divider dark></v-divider>
                <v-chip-group column class="md-fixed-max-width">
                  <v-chip
                    label
                    small
                    class="ma-2"
                    v-for="group in item.groups"
                    :key="group._id"
                  >
                    <div class="mb-0 caption">{{ group.title }}</div>
                  </v-chip>
                </v-chip-group>
              </v-tooltip>
            </template>
            <template v-slot:item.active="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-switch
                    v-on="on"
                    color="rgb(66, 154, 216)"
                    inset
                    v-model="item.active"
                    @click="
                      item.actice == true || arrBundles.length == 1
                        ? openModalWarning(item)
                        : openModalStatus(item)
                    "
                  ></v-switch>
                </template>
                <span v-if="item.active">Click to Suspend</span>
                <span v-else>Click to Activate</span>
              </v-tooltip>
            </template>
            <template v-slot:item.action="{ item }">
              <v-row align="center" justify="center">
                <v-btn
                  elevation="0"
                  class="mb-0 body-2 text-primary text-capitalize"
                  color="white"
                  @click="openDialogAddBundle(item._id)"
                >
                  <p class="mb-0">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseList.edit'
                      )
                    }}
                  </p>
                </v-btn>
                <v-divider inset vertical class="mb-2 mx-1"></v-divider>
                <v-btn
                  elevation="0"
                  class="mb-0 body-2 error--text text-capitalize"
                  color="white"
                  :disabled="item.active == true || arrBundles.length == 1"
                  @click="openDeleteDialog(item._id)"
                >
                  <p class="mb-0">Delete</p>
                </v-btn>
              </v-row>
              
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <v-row no-gutters class="mb-6">
        <v-col cols="12">
          <div class="text-center">
            <v-pagination
              v-model="params.page"
              :length="pageCount"
              @input="changePage"
            ></v-pagination>
          </div>
        </v-col>
      </v-row>
    </div> -->

    <v-dialog v-model="openDeleteDialogStatus" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.alertDeleteLesson'
            )
          }}
        </v-card-title>
        <v-card-text>
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.live.alertDeleteCantBringData'
            )
          }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="px-9 ma-2 button-secondary font-weight-light"
            outlined
            @click="openDeleteDialogStatus = false"
          >
            {{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.cancel')
            }}
          </v-btn>
          <v-btn
            class="px-10 ma-2 font-weight-light"
            large
            color="error "
            dark
            rounded
          >
            {{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.confirm')
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAddBundle" persistent scrollable max-width="600px">
      <v-form ref="form" v-model="valid" v-on:submit.prevent="beforeSubmit">
        <v-card tile>
          <v-toolbar flat dark color="rgb(51, 97, 137)">
            <v-toolbar-title>
              <v-icon left>mdi-shopping</v-icon
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.bundle.dialogBundle.headerTitile'
                )
              }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn icon dark @click="closeDialog" v-on="on">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span class="subtitle-1">{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.bundle.dialogBundle.close'
                )
              }}</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <p class="mb-2 body-1 font-weight-medium">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.bundle.dialogBundle.name'
                    )
                  }}<span class="font-weight-bold error--text">*</span>
                </p>

                <v-text-field
                  :rules="titleRules"
                  outlined
                  v-model="title"
                  clearable
                ></v-text-field>

                <p class="mb-2 body-1 font-weight-medium">
                  {{ $vuetify.lang.t('$vuetify.pricing')
                  }}<span class="font-weight-bold error--text">*</span>
                </p>

                <v-text-field
                  v-model="price"
                  :rules="priceRules"
                  @change="checkMinPrice"
                  type="number"
                  min="1"
                  outlined
                ></v-text-field>

                <p class="mb-2 body-1 font-weight-medium">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.bundle.dialogBundle.description'
                    )
                  }}
                </p>
                <v-textarea
                  v-model="description"
                  counter
                  :value="description"
                  outlined
                  no-resize
                  height="150"
                ></v-textarea>

                <p class="mb-2 body-1 font-weight-medium">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.bundle.dialogBundle.image'
                    )
                  }}
                </p>

                <div class="img-list-preview">
                  <v-row>
                    <v-col cols="4">
                      <div class="img-panel">
                        <v-img
                          :src="imgPreview == null ? imageReady1 : imgPreview"
                          :lazy-src="imgPreview"
                          aspect-ratio="1"
                          contain
                          height="115px"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-icon
                                v-if="imageReady1 == false"
                                class="mx-auto"
                                elevation="3"
                                size="80"
                                color="grey lighten-4"
                                >mdi-image</v-icon
                              >
                            </v-row>
                          </template>
                        </v-img>
                      </div>
                    </v-col>
                    <v-col cols="7">
                      <!-- <div class="progressContainer"> -->
                      <p class="mb-0">
                        {{
                          imageName
                            ? imageName
                            : $vuetify.lang.t(
                                '$vuetify.courseManagement.bundle.dialogBundle.bundleImage'
                              )
                        }}
                      </p>
                      <!-- <div class="d-flex"> -->
                      <v-progress-linear
                        class="progress mt-2"
                        reactive
                        rounded
                        :value="progressPercent"
                        height="5"
                        width="100%"
                      ></v-progress-linear>
                      <!-- </div> -->
                      <!-- </div> -->
                    </v-col>
                    <v-col
                      cols="1"
                      style="justify-content: center; display: inherit"
                    >
                      <p class="mb-0 mt-5">{{ progressPercent }}%</p>
                    </v-col>
                  </v-row>
                </div>
                <v-row class="mb-5">
                  <v-col class="py-0" cols="4">
                    <a>
                      <div class="upload-btn-wrapper text-center">
                        <v-btn class="mr-1 btn-reload body-1 font-weight-light">
                          <v-icon left>mdi-upload</v-icon>
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.bundle.dialogBundle.chooseFile'
                            )
                          }}
                        </v-btn>
                        <input
                          type="file"
                          accept="image/*"
                          name="myfile"
                          @change="preview"
                        />
                      </div>
                    </a>
                  </v-col>
                </v-row>
                <p class="mb-2 body-1 font-weight-medium">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.bundle.dialogBundle.groupOption'
                    )
                  }}
                </p>

                <v-radio-group v-model="selectGroup" row class="mt-0 pt-0 mb-2">
                  <v-radio
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.bundle.dialogBundle.groupOptionAll'
                      )
                    "
                    :value="false"
                    class="mr-md-12"
                  ></v-radio>
                  <v-radio
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.bundle.dialogBundle.groupOptionOnly'
                      )
                    "
                    :value="true"
                    class
                  ></v-radio>
                </v-radio-group>

                <div v-if="selectGroup == true">
                  <p class="mb-2 body-1 font-weight-medium">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.bundle.dialogBundle.group'
                      )
                    }}<span class="font-weight-bold error--text">*</span>
                  </p>
                  <v-combobox
                    class="mb-5"
                    v-model="selection"
                    :rules="groupRules"
                    :items="arrayGroup"
                    item-text="title"
                    item-value="_id"
                    :placeholder="
                      $vuetify.lang.t(
                        '$vuetify.learnerManagement.filterBar.selectGroup'
                      )
                    "
                    hide-details
                    outlined
                    dense
                    multiple
                    required
                    small-chips
                    background-color="white"
                  >
                    <template
                      v-slot:selection="{ attrs, item, parent, selected }"
                    >
                      <v-chip
                        class="ma-1"
                        v-if="item === Object(item)"
                        v-bind="attrs"
                        :input-value="selected"
                        label
                        small
                      >
                        <span class="pr-2">
                          {{ item.title }}
                        </span>
                        <v-icon small @click="parent.selectItem(item)">
                          mdi-close-circle
                        </v-icon>
                      </v-chip>
                    </template></v-combobox
                  >

                  <!-- <div>
                    <v-autocomplete
                      v-model="selection"
                      :rules="groupRules"
                      :items="arrayGroup"
                      item-text="title"
                      item-value="_id"
                      :placeholder="
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.bundle.dialogBundle.selectGroup'
                        )
                      "
                      class="subtitle-2 font-weight-light"
                      solo
                      dense
                      flat
                      multiple
                      outlined
                      deletable-chips
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          class="ma-1"
                          v-bind="data.attrs"
                          :input-value="data.selected"
                          close
                          small
                          label
                          @click="data.select"
                          @click:close="removeByUser(data.item)"
                          >{{ data.item.title }}</v-chip
                        >
                      </template>
                    </v-autocomplete>
                  </div> -->
                </div>
                <!-- <div>
                  <v-autocomplete
                    :rules="groupRules"
                    :items="arrayGroup"
                    item-text="title"
                    item-value="_id"
                    append-icon
                    chips
                    small-chips
                    readonly
                    solo
                    flat
                    dense
                    multiple
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        class="ma-1"
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        small
                        label
                        @click="data.select"
                        @click:close="removeByUser(data.item)"
                        >{{ data.item.title }}</v-chip
                      >
                    </template>
                  </v-autocomplete>
                </div> -->

                <p class="mb-2 body-1 font-weight-medium">
                  {{ $vuetify.lang.t('$vuetify.duration') }}
                </p>
                <v-radio-group v-model="selectDuration" row class="mt-0 pt-0">
                  <v-radio
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.bundle.dialogBundle.lifeLong'
                      )
                    "
                    :value="1"
                    class="mr-md-12"
                  ></v-radio>
                  <v-radio
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.bundle.dialogBundle.DateSetType'
                      )
                    "
                    :value="2"
                    class="mr-md-12"
                  ></v-radio>
                  <v-radio
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.bundle.dialogBundle.DaySetType'
                      )
                    "
                    :value="3"
                  ></v-radio>
                </v-radio-group>
                <p
                  class="mb-2 body-1 font-weight-medium"
                  v-if="selectDuration == 3"
                >
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.bundle.dialogBundle.day'
                    )
                  }}
                </p>
                <v-text-field
                  v-if="selectDuration == 3"
                  v-model="durationTypeDay"
                  type="number"
                  min="1"
                  :rules="typeDayRules"
                  @change="checkMinDay"
                  outlined
                ></v-text-field>
                <p
                  class="mb-2 body-1 font-weight-medium"
                  v-if="selectDuration == 2"
                >
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.bundle.dialogBundle.dateType'
                    )
                  }}
                </p>
                <v-card
                  class="px-3 mb-5"
                  color="grey lighten-5"
                  elevation="0"
                  v-if="selectDuration == 2"
                >
                  <v-row>
                    <v-col lg="7" cols="12">
                      <p class="ml-8 mb-2 grey--text">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.bundle.dialogBundle.date'
                          )
                        }}
                      </p>
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="dateExp"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="dateExp"
                            label
                            prepend-icon="event"
                            background-color="white"
                            persistent-hint
                            readonly
                            outlined
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="dateExp"
                          no-title
                          :min="nowDate"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu = false">{{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.bundle.dialogBundle.cancel'
                            )
                          }}</v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu.save(dateExp)"
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.bundle.dialogBundle.ok'
                              )
                            }}</v-btn
                          >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col lg="2" cols="6" class="pr-md-0">
                      <p class="mb-2 grey--text">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.bundle.dialogBundle.hour'
                          )
                        }}
                      </p>
                      <v-autocomplete
                        v-model="hourExp"
                        :items="arr_hour"
                        background-color="white"
                        outlined
                      ></v-autocomplete>
                    </v-col>
                    <v-col lg="1" class="position-relative">
                      <div class="colon">
                        <p class="mb-0 font-weight-bold">:</p>
                      </div>
                    </v-col>
                    <v-col lg="2" cols="6" class="pl-md-0">
                      <p class="mb-2 grey--text">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.bundle.dialogBundle.minute'
                          )
                        }}
                      </p>
                      <v-autocomplete
                        v-model="minExp"
                        :items="arr_minute"
                        outlined
                        background-color="white"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-card>

                <p class="mb-2 body-1 font-weight-medium">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.bundle.dialogBundle.status'
                    )
                  }}
                </p>

                <v-radio-group
                  v-model="selectStatus"
                  row
                  class="mt-0 pt-0 mb-2"
                >
                  <v-radio
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.bundle.dialogBundle.statusOn'
                      )
                    "
                    :value="1"
                    class="mr-md-12"
                  ></v-radio>
                  <v-radio
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.bundle.dialogBundle.statusOff'
                      )
                    "
                    :value="2"
                    class
                  ></v-radio>
                </v-radio-group>

                <p class="mb-2 body-1 font-weight-medium">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.bundle.dialogBundle.startDatePublish'
                    )
                  }}<span class="font-weight-bold error--text">*</span>
                </p>

                <v-card class="px-3 mb-5" color="grey lighten-5" elevation="0">
                  <v-row>
                    <v-col lg="7" cols="12">
                      <p class="ml-8 mb-2 grey--text">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.bundle.dialogBundle.date'
                          )
                        }}
                      </p>
                      <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        :return-value.sync="dateStart"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="dateStart"
                            label
                            prepend-icon="event"
                            background-color="white"
                            persistent-hint
                            readonly
                            outlined
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="dateStart"
                          no-title
                          :min="nowDate"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu1 = false">{{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.bundle.dialogBundle.cancel'
                            )
                          }}</v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu1.save(dateStart)"
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.bundle.dialogBundle.ok'
                              )
                            }}</v-btn
                          >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col lg="2" cols="6" class="pr-md-0">
                      <p class="mb-2 grey--text">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.bundle.dialogBundle.hour'
                          )
                        }}
                      </p>
                      <v-autocomplete
                        v-model="hourStart"
                        :items="arr_hour"
                        background-color="white"
                        outlined
                      ></v-autocomplete>
                    </v-col>
                    <v-col lg="1" class="position-relative">
                      <div class="colon">
                        <p class="mb-0 font-weight-bold">:</p>
                      </div>
                    </v-col>
                    <v-col lg="2" cols="6" class="pl-md-0">
                      <p class="mb-2 grey--text">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.bundle.dialogBundle.minute'
                          )
                        }}
                      </p>
                      <v-autocomplete
                        v-model="minStart"
                        :items="arr_minute"
                        outlined
                        background-color="white"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-card>

                <p class="mb-2 body-1 font-weight-medium">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.bundle.dialogBundle.endDatePublish'
                    )
                  }}<span class="font-weight-bold error--text">*</span>
                </p>

                <v-card class="px-3 mb-5" color="grey lighten-5" elevation="0">
                  <v-row>
                    <v-col lg="7" cols="12">
                      <p class="ml-8 mb-2 grey--text">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.bundle.dialogBundle.date'
                          )
                        }}
                      </p>
                      <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :return-value.sync="dateEnd"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                        background-color="white"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="dateEnd"
                            label
                            prepend-icon="event"
                            persistent-hint
                            background-color="white"
                            readonly
                            outlined
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="dateEnd"
                          no-title
                          :min="nowDate"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu2 = false">{{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.bundle.dialogBundle.cancel'
                            )
                          }}</v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu2.save(dateEnd)"
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.bundle.dialogBundle.ok'
                              )
                            }}</v-btn
                          >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col lg="2" cols="6" class="pr-md-0">
                      <p class="mb-2 grey--text">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.bundle.dialogBundle.hour'
                          )
                        }}
                      </p>
                      <v-autocomplete
                        v-model="hourEnd"
                        :items="arr_hour"
                        background-color="white"
                        outlined
                      ></v-autocomplete>
                    </v-col>
                    <v-col lg="1" class="position-relative">
                      <div class="colon">
                        <p class="mb-0 font-weight-bold">:</p>
                      </div>
                    </v-col>
                    <v-col lg="2" cols="6" class="pl-md-0">
                      <p class="mb-2 grey--text">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.bundle.dialogBundle.minute'
                          )
                        }}
                      </p>
                      <v-autocomplete
                        v-model="minEnd"
                        :items="arr_minute"
                        outlined
                        background-color="white"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <!-- <v-row>
              <v-col cols="12">
                <v-row>
                  <v-col cols="6">
                    <v-radio-group v-model="selectPrice" row class="mt-0 pt-0">
                      <v-radio
                        label="ฟรี"
                        :value="1"
                        class="mr-md-12"
                      ></v-radio>
                      <v-radio label="ราคา" :value="2" class></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      :disabled="selectPrice == 2 ? false : true"
                      v-model="price"
                      :rules="this.selectPrice == 1 ? false : priceRules"
                      @change="checkMinPrice"
                      type="number"
                      min="1"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row> -->
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              elevation="0"
              class="
                px-9
                ma-2
                subtitle-2
                button-secondary
                font-weight-light
                text-capitalize
              "
              outlined
              @click="closeDialog"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.bundle.dialogBundle.cancel'
                )
              }}</v-btn
            >
            <v-btn
              elevation="0"
              class="
                px-10
                ma-2
                subtitle-2
                text-capitalize
                font-weight-light
                button-primary
              "
              :disabled="!validationForm()"
              @click="validate"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.bundle.dialogBundle.save'
                )
              }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="dialogGroupUser" scrollable persistent max-width="800px">
      <v-form ref="form" v-model="valid" v-on:submit.prevent="validate">
        <v-card>
          <v-toolbar flat dark color="rgb(51, 97, 137)">
            <v-spacer></v-spacer>
            <v-toolbar-title class="font-weight-light text-center ml-12">{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.bundle.dialogBundle.group'
              )
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogGroupUser = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <div class="pt-10 px-3">
              <v-autocomplete
                v-model="selection"
                :rules="groupRules"
                :items="arrayGroup"
                item-text="title"
                item-value="_id"
                append-icon="search"
                class="text-field-border mb-5"
                chips
                small-chips
                solo
                flat
                dense
                multiple
                :hint="
                  selection.length > 0
                    ? `${selection.length} selected group(s)`
                    : ``
                "
                persistent-hint
                placeholder="Search Groups"
              >
                <template v-slot:selection="data">
                  <div
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    small
                    @click="data.select"
                    @click:close="removeByUser(data.item)"
                  ></div>
                </template>
              </v-autocomplete>
            </div>
            <div class="px-0">
              <v-autocomplete
                v-model="selection"
                :items="arrayGroup"
                item-text="title"
                item-value="_id"
                required
                append-icon
                chips
                small-chips
                multiple
                readonly
                solo
                flat
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    label
                    small
                    @click="data.select"
                    @click:close="removeByUser(data.item)"
                    >{{ data.item.title }}</v-chip
                  >
                </template>
              </v-autocomplete>
            </div>

            <div
              v-for="(group, groupIndex) in arrayGroup"
              :key="groupIndex"
              class="px-3"
            >
              <v-checkbox
                v-model="selection"
                :label="group.title"
                :value="group._id"
                class="py-0 my-0 font-weight-light"
              ></v-checkbox>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              elevation="0"
              class="
                px-9
                ma-2
                subtitle-2
                button-secondary
                font-weight-light
                text-capitalize
              "
              outlined
              @click="dialogGroupUser = false"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.bundle.dialogBundle.cancel'
                )
              }}</v-btn
            >
            <v-btn
              elevation="0"
              class="px-10 ma-2 subtitle-2 font-weight-light button-primary"
              @click="validate"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.bundle.dialogBundle.save'
                )
              }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="dialogStatus" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.courseManagement.bundle.warningMsg1')
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.lang.t('$vuetify.courseManagement.bundle.warningMsg2')
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="px-9 ma-2 button-secondary font-weight-light"
            dark
            outlined
            @click="cancelStatus()"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.bundle.cancel')
            }}</v-btn
          >
          <v-btn
            color="error"
            class="px-10 ma-2"
            dark
            @click="bundleUpdateActive()"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.bundle.confirm')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogStatusActive" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.courseManagement.bundle.warningMsg5')
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.lang.t('$vuetify.courseManagement.bundle.warningMsg6')
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="px-10 ma-2 button-secondary font-weight-light"
            dark
            outlined
            @click="cancelStatusActive()"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.bundle.cancel')
            }}</v-btn
          >
          <v-btn
            class="px-10 ma-2 button-primary white--text font-weight-light"
            dark
            @click="bundleUpdateActive()"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.bundle.confirm')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.courseManagement.bundle.warningMsg7')
        }}</v-card-title>

        <v-card-text>{{
          $vuetify.lang.t('$vuetify.courseManagement.bundle.warningMsg8')
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialogSuccess = false">{{
            $vuetify.lang.t('$vuetify.courseManagement.bundle.done')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogUpdateSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.courseManagement.bundle.warningMsg7')
        }}</v-card-title>

        <v-card-text>{{
          $vuetify.lang.t('$vuetify.courseManagement.bundle.warningMsg9')
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="closeDialog">{{
            $vuetify.lang.t('$vuetify.courseManagement.bundle.done')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.courseManagement.bundle.warningMsg3')
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.lang.t('$vuetify.courseManagement.bundle.warningMsg4')
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="px-9 ma-2 button-secondary font-weight-light"
            dark
            outlined
            @click="dialogDelete = false"
          >
            {{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.cancel')
            }}
          </v-btn>
          <v-btn
            class="px-10 ma-2 font-weight-light"
            color="error "
            dark
            @click="deleteBundle"
          >
            {{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.confirm')
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeleteSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.courseManagement.bundle.warningMsg10')
        }}</v-card-title>

        <v-card-text>
          {{ $vuetify.lang.t('$vuetify.courseManagement.bundle.warningMsg11') }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialogDeleteSuccess = false"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.bundle.done')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogWarning" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.courseManagement.bundle.warningMsg12')
        }}</v-card-title>
        <v-card-text
          v-if="this.expTime <= this.endTime || this.expTime <= this.startTime"
          >&nbsp;-&nbsp;{{
            $vuetify.lang.t('$vuetify.courseManagement.bundle.warningMsg13')
          }}</v-card-text
        >

        <v-card-text v-if="this.startTime >= this.endTime">
          &nbsp;-&nbsp;{{
            $vuetify.lang.t('$vuetify.courseManagement.bundle.warningMsg14')
          }}
        </v-card-text>
        <v-card-text
          v-if="this.selectGroup == true && this.selection.length == 0"
          >&nbsp;-&nbsp;{{
            $vuetify.lang.t('$vuetify.courseManagement.bundle.warningMsg15')
          }}</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="dialogWarning = false"
            >{{ $vuetify.lang.t('$vuetify.courseManagement.bundle.ok') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogStatusWarning" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.courseManagement.bundle.warningMsg16')
        }}</v-card-title>
        <v-card-text>
          &nbsp;-&nbsp;{{
            $vuetify.lang.t('$vuetify.courseManagement.bundle.warningMsg17')
          }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="confirmModalWarning"
            >{{ $vuetify.lang.t('$vuetify.courseManagement.bundle.ok') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  getListBundles,
  updateBundles,
  insertBundles,
  updateBundlesActive,
  deleteBundles,
  getCourseById,
  updateCourse,
} from '@/service/course/course';
import { cleaningData } from '@/helper/cleaningData';
import { headersWithTokenForImage, domain } from '@/service/configApi';
import { getUserGroup } from '@/service/account/manageUser';
import axios from 'axios';
// import {numFormat} from 'vue-filter-number-format';
export default {
  components: {},
  computed: {
    headerTable() {
      return [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.bundle.headerTable.image'
          ),
          align: 'center',
          sortable: false,
          value: 'images',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.bundle.headerTable.name'
          ),
          align: 'start',
          sortable: false,
          value: 'title',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.bundle.headerTable.price'
          ),
          align: 'center',
          sortable: false,
          value: 'price',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.bundle.headerTable.startDate'
          ),
          align: 'center',
          sortable: false,
          value: 'startTime',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.bundle.headerTable.endDate'
          ),
          align: 'center',
          sortable: false,
          value: 'endTime',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.bundle.headerTable.group'
          ),
          align: 'center',
          sortable: false,
          value: 'groups',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.bundle.headerTable.status'
          ),
          align: 'start',
          sortable: false,
          value: 'active',
        },
        {
          // text: this.$vuetify.lang.t(
          //   '$vuetify.courseManagement.bundle.headerTable.action'
          // ),
          align: 'center',
          sortable: false,
          value: 'action',
        },
      ];
    },
  },
  data() {
    return {
      dialogAddBundle: false,
      dialogUpdateSuccess: false,
      openDeleteDialogStatus: false,
      dialogStatus: false,
      dialogStatusActive: false,
      dialogSuccess: false,
      dialogDelete: false,
      dialogDeleteSuccess: false,
      dialogGroupUser: false,
      dialogWarning: false,
      dialogStatusWarning: false,

      courseID: '',
      imageReady: false,
      imageReady1: false,
      imageName: '',
      status_toggle: 0,
      arrBundles: [],
      searchdata: '',
      params: {},
      loading: false,
      page: 1,
      limit: 10,
      pageCount: 0,
      deleteId: null,
      imgBool: false,
      imgPreview: null,
      progressPercent: 0,
      valid: false,

      selectionGroup: [],
      selection: [],
      arrayGroup: [],
      userGroupSearch: [],
      arrGroupTitle: [],
      selectDuration: 1,
      // selectPrice: 1,
      selectGroup: false,
      selectStatus: 1,
      durationTypeDay: 1,
      typeExp: '',
      idcourse: '',
      dateExp: new Date().toISOString().substr(0, 10),
      dateStart: new Date().toISOString().substr(0, 10),
      dateEnd: new Date().toISOString().substr(0, 10),
      nowDate: new Date().toISOString().slice(0, 10),

      menu: false,
      menu1: false,
      menu2: false,
      modal: false,
      menu_enddate: false,
      expTime: 0,
      startTime: 0,
      endTime: 0,
      fixTime: 0,
      fixTimeStart: 0,
      hourExp: 0,
      minExp: 0,
      hourStart: 0,
      minStart: 0,
      hourEnd: 0,
      minEnd: 0,
      idBundlesEdit: '',
      title: '',
      price: 1,
      description: '',
      expireType: '',
      imageFile: null,
      indexItem: null,
      bundleOption: false,
      detail: [],

      groupRules: [(v) => !!v || 'User Group is Required'],
      titleRules: [(v) => !!v || 'Bundle name is require'],
      durationTypeRules: [
        (v) => !!v || this.$vuetify.lang.t('$vuetify.plsChooseDurationType'),
      ],
      priceRules: [
        (v) => !!v >= 1 || this.$vuetify.lang.t('$vuetify.choosePrice'),
      ],
      typeDayRules: [
        (v) => !!v >= 1 || this.$vuetify.lang.t('$vuetify.typeDay'),
      ],
      imageRules: [
        (v) =>
          !v ||
          v.size < 20000000 ||
          this.$vuetify.lang.t('$vuetify.plsChooseUnder20MB'),
      ],

      arr_hour: [
        { text: '00', value: 0 },
        { text: '01', value: 1 },
        { text: '02', value: 2 },
        { text: '03', value: 3 },
        { text: '04', value: 4 },
        { text: '05', value: 5 },
        { text: '06', value: 6 },
        { text: '07', value: 7 },
        { text: '08', value: 8 },
        { text: '09', value: 9 },
        { text: '10', value: 10 },
        { text: '11', value: 11 },
        { text: '12', value: 12 },
        { text: '13', value: 13 },
        { text: '14', value: 14 },
        { text: '15', value: 15 },
        { text: '16', value: 16 },
        { text: '17', value: 17 },
        { text: '18', value: 18 },
        { text: '19', value: 19 },
        { text: '20', value: 20 },
        { text: '21', value: 21 },
        { text: '22', value: 22 },
        { text: '23', value: 23 },
      ],
      arr_minute: [
        { text: '00', value: 0 },
        { text: '01', value: 1 },
        { text: '02', value: 2 },
        { text: '03', value: 3 },
        { text: '04', value: 4 },
        { text: '05', value: 5 },
        { text: '06', value: 6 },
        { text: '07', value: 7 },
        { text: '08', value: 8 },
        { text: '09', value: 9 },
        { text: '10', value: 10 },
        { text: '11', value: 11 },
        { text: '12', value: 12 },
        { text: '13', value: 13 },
        { text: '14', value: 14 },
        { text: '15', value: 15 },
        { text: '16', value: 16 },
        { text: '17', value: 17 },
        { text: '18', value: 18 },
        { text: '19', value: 19 },
        { text: '20', value: 20 },
        { text: '21', value: 21 },
        { text: '22', value: 22 },
        { text: '23', value: 23 },
        { text: '24', value: 24 },
        { text: '25', value: 25 },
        { text: '26', value: 26 },
        { text: '27', value: 27 },
        { text: '28', value: 28 },
        { text: '29', value: 29 },
        { text: '30', value: 30 },
        { text: '31', value: 31 },
        { text: '32', value: 32 },
        { text: '33', value: 33 },
        { text: '34', value: 34 },
        { text: '35', value: 35 },
        { text: '36', value: 36 },
        { text: '37', value: 37 },
        { text: '38', value: 38 },
        { text: '39', value: 39 },
        { text: '40', value: 40 },
        { text: '41', value: 41 },
        { text: '42', value: 42 },
        { text: '43', value: 43 },
        { text: '44', value: 44 },
        { text: '45', value: 45 },
        { text: '46', value: 46 },
        { text: '47', value: 47 },
        { text: '48', value: 48 },
        { text: '49', value: 49 },
        { text: '50', value: 50 },
        { text: '51', value: 51 },
        { text: '52', value: 52 },
        { text: '53', value: 53 },
        { text: '54', value: 54 },
        { text: '55', value: 55 },
        { text: '56', value: 56 },
        { text: '57', value: 57 },
        { text: '58', value: 58 },
        { text: '59', value: 59 },
      ],

      pricingOptionSaving: false,
      pricingOptionSuccess: false,
      pricingOptionFail: false,
    };
  },
  mounted() {
    this.initialize();
  },
  watch: {
    // searchdata(keyword) {
    //   this.searchInfo(keyword);
    // }
  },
  methods: {
    async initialize() {
      console.log('course : ', this.$route);
      this.params = {
        idcourse: this.$route.query.id,
        page: this.page,
        limit: 10,
      };
      this.active = 'null';
      this.status_toggle = 0;

      await this.getUserGroupList();
      await this.getBundelsList();
      await this.getCourseDetail();

      //if (this.detail.useBundle || this.arrBundles.length > 0) {
      //  this.bundleOption = true;
      //} else {
      //  this.bundleOption = false;
      //}

      // dateExp: new Date().toISOString().substr(0, 10),
      // dateStart: new Date().toISOString().substr(0, 10),
      // dateEnd: new Date().toISOString().substr(0, 10),
      // nowDate: new Date().toISOString().slice(0, 10),
    },
    beforeSubmit() {
      console.log('***');
    },
    removeByUser(item) {
      const index = this.selection.indexOf(item._id);
      if (index >= 0) this.selection.splice(index, 1);
    },
    async changePage(page) {
      this.page = page;
      await this.getBundelsList();
    },
    validationForm() {
      if (this.title != '') {
        this.valid = true;
      }
      return this.valid;
    },
    closeDialog() {
      this.dialogUpdateSuccess = false;
      this.dialogAddBundle = false;
      this.dialogGroupUser = false;
      this.clearData();
    },
    clearData() {
      this.initialize();
      this.title = '';
      this.expireType = '';
      this.price = 1;
      this.description = '';
      this.imgPreview = null;
      this.progressPercent = 0;
      this.selection = [];
      this.arrGroupTitle = [];
      this.selectDuration = 1;
      // this.selectPrice = 1;
      this.selectGroup = false;
      this.selectStatus = 1;
      this.durationTypeDay = 1;
      this.dateExp = new Date().toISOString().substr(0, 10);
      this.dateStart = new Date().toISOString().substr(0, 10);
      this.dateEnd = new Date().toISOString().substr(0, 10);
      this.nowDate = new Date().toISOString().slice(0, 10);
      this.hourStart = 0;
      this.minStart = 0;
      this.hourEnd = 0;
      this.minEnd = 0;
      this.hourExp = 0;
      this.minExp = 0;
      this.indexItem = null;

      this.idBundlesEdit = '';
      this.imageName = '';
      this.imageReady = false;
      this.imageReady1 = false;

      this.$refs.form.resetValidation();
    },
    checkMinPrice() {
      if (this.price <= 0) this.price = 1;
    },
    checkMinDay() {
      if (this.durationTypeDay <= 0) this.durationTypeDay = 1;
    },
    async getCourseDetail() {
      let params = {
        id: this.$route.query.id,
      };
      let detail = await getCourseById(params);
      this.detail = detail;
      this.bundleOption = detail.useBundle;
      // console.log("this.detail", this.detail)
      // this.userGroupSelect = detail.user_groups;
      // this.userGroupSelect = detail.user_groups;
      // this.learningOrder = detail.learningOrder;
      // this.haveDashboard = detail.haveDashboard;
      // this.haveInbox = detail.haveInbox;
    },
    async getBundelsList() {
      let bundelsDetail = await getListBundles(this.params);
      // this.arrBundles = bundelsDetail.data;
      this.pageCount = bundelsDetail.maxPage;
      this.arrBundles = [];
      await bundelsDetail.data.forEach(async (bundle) => {
        this.arrBundles.push({
          _id: bundle._id,
          title: bundle.title,
          images: bundle.images,
          description: bundle.description,
          startTime: bundle.startTime,
          endTime: bundle.endTime,
          price: bundle.price,
          items: bundle.items,
          active: bundle.active,
          groups: await this.showGroupList(bundle.groups),
        });
      });
      this.imageReady = true;
    },
    async showGroupList(userGroup) {
      let userGroupOutput = [];
      await userGroup.forEach(
        async (grouplist) =>
          await this.arrayGroup.forEach(async (groups) =>
            groups._id == grouplist._id
              ? await userGroupOutput.push(groups)
              : null
          )
      );
      return userGroupOutput;
    },
    async getUserGroupList() {
      let result = await getUserGroup(this.params);
      this.groupUsers = [];
      // let userGroupAllAtIndex=[]
      this.arrayGroup = [];
      await result.forEach(async (group) => {
        // let arrayGroup = []
        group.child_User_Group.length === 0
          ? await this.groupUsers.push({
              title: group.title,
              _id: group._id,
            })
          : null;
        group.child_User_Group.forEach(async (child) => {
          child.child_User_Group.length === 0
            ? await this.groupUsers.push({
                title: group.title + ' -> ' + child.title,
                _id: child._id,
              })
            : null;
          child.child_User_Group.forEach(async (lastChild) => {
            await this.groupUsers.push({
              title:
                group.title + ' -> ' + child.title + ' -> ' + lastChild.title,
              _id: lastChild._id,
            });
          });
        });
        // await userGroupAllAtIndex.push({arrayGroup})
      });
      this.arrayGroup = this.groupUsers;
      // this.groupUsers = result;
      // this.filterGroupResult = result;
    },

    async getUserGroup(item) {
      this.dialogGroupUser = true;
      this.idBundlesEdit = item._id;
      let index = this.arrBundles.indexOf(item);

      if (this.idBundlesEdit) {
        this.selection = this.arrBundles[index].groups.map(
          (group) => group._id
        );
      }
      for (var i = 0; i < this.arrBundles.length; i++) {
        if (this.idBundlesEdit == this.arrBundles[i]._id) {
          this.arrBundles[i].groups.forEach((idgroup) => {
            this.arrayGroup.forEach((value) => {
              if (idgroup === value._id) {
                this.arrGroupTitle.push({
                  id: value._id,
                  title: value.title,
                });
              }
            });
          });

          this.title = this.arrBundles[i].title;
          this.price = this.arrBundles[i].price;
          this.description = this.arrBundles[i].description;
          this.imgPreview = this.arrBundles[i].images;
          if (this.imgPreview) {
            this.imageReady = true;
          }
          this.expireType = this.arrBundles[i].items[0].expireType;
          this.durationTypeDay = this.arrBundles[i].items[0].duration;
          // this.selection = this.arrBundles[i].groups;
          this.dateStart = new Date(this.arrBundles[i].startTime)
            .toISOString()
            .substr(0, 10);
          this.dateEnd = new Date(this.arrBundles[i].endTime)
            .toISOString()
            .substr(0, 10);

          if (this.arrBundles[i].items[0].expireDate == 0) {
            this.dateExp = new Date().toISOString().substr(0, 10);
          } else {
            this.dateExp = new Date(this.arrBundles[i].expireDate)
              .toISOString()
              .substr(0, 10);
          }

          var hour_exp = new Date(this.arrBundles[i].items[0].expireDate)
            .toISOString()
            .substr(11, 2);
          var min_exp = new Date(this.arrBundles[i].items[0].expireDate)
            .toISOString()
            .substr(14, 2);

          var hour_start = new Date(this.arrBundles[i].startTime)
            .toISOString()
            .substr(11, 2);
          var min_start = new Date(this.arrBundles[i].startTime)
            .toISOString()
            .substr(14, 2);

          var hour_end = new Date(this.arrBundles[i].endTime)
            .toISOString()
            .substr(11, 2);
          var min_end = new Date(this.arrBundles[i].endTime)
            .toISOString()
            .substr(14, 2);

          this.hourExp = parseInt(hour_exp);
          this.minExp = parseInt(min_exp);
          this.hourStart = parseInt(hour_start);
          this.minStart = parseInt(min_start);
          this.hourEnd = parseInt(hour_end);
          this.minEnd = parseInt(min_end);
        }
      }
    },
    async applyFilter() {
      if (this.status_toggle == 1) {
        this.params.active = true;
        await this.getBundelsList();
      } else if (this.status_toggle == 2) {
        this.params.active = false;
        await this.getBundelsList();
      } else {
        this.params.active = 'null';
        await this.getBundelsList();
      }
    },
    checkActiveStatus() {},
    openModalStatus(item) {
      let index = this.arrBundles.indexOf(item);
      this.indexItem = index;
      if (this.arrBundles[index].active == true) {
        this.dialogStatus = true;
        this.idBundlesEdit = this.arrBundles[index]._id;
        this.updateActive = this.arrBundles[index].active;
      } else {
        this.dialogStatusActive = true;
        this.idBundlesEdit = this.arrBundles[index]._id;
        this.updateActive = this.arrBundles[index].active;
      }
    },
    cancelStatus() {
      this.dialogStatus = false;
      this.arrBundles[this.indexItem].active = this.updateActive;
    },
    cancelStatusActive() {
      this.dialogStatusActive = false;
      this.arrBundles[this.indexItem].active = this.updateActive;
    },
    openModalWarning(item) {
      let index = this.arrBundles.indexOf(item);
      this.indexItem = index;
      if (this.arrBundles[index].active == true) {
        this.idBundlesEdit = this.arrBundles[index]._id;
        this.updateActive = this.arrBundles[index].active;
      } else {
        this.idBundlesEdit = this.arrBundles[index]._id;
        this.updateActive = this.arrBundles[index].active;
      }
      this.dialogStatusWarning = true;
    },
    confirmModalWarning() {
      this.dialogStatusWarning = false;
      this.arrBundles[this.indexItem].active = this.updateActive;
    },

    async bundleUpdateActive() {
      if (this.updateActive == true) {
        let status = await updateBundlesActive({
          idbundles: this.idBundlesEdit,
          active: false,
        });
        this.dialogStatus = false;
        this.dialogSuccess = true;
        this.getBundelsList();
        return status;
      } else {
        let status = await updateBundlesActive({
          idbundles: this.idBundlesEdit,
          active: true,
        });
        this.dialogStatusActive = false;
        this.dialogSuccess = true;
        this.getBundelsList();
        return status;
      }
    },
    openDeleteDialog(idbundle) {
      this.idBundlesEdit = idbundle;
      this.dialogDelete = true;
    },
    async deleteBundle() {
      let status = await deleteBundles({
        idbundles: this.idBundlesEdit,
      });
      this.dialogDelete = false;
      this.dialogDeleteSuccess = true;
      this.getBundelsList();
      return status;
    },
    async preview(event) {
      let file = event.target.files[0];

      this.imageFile = file;
      this.imgPreview = await URL.createObjectURL(file);
      this.imageName = file.name;
      if (this.imgPreview) {
        this.imageReady1 = true;
      }
      this.imgBool = true;
    },
    openDialogAddBundle(idcourse) {
      this.idBundlesEdit = idcourse;
      this.dialogAddBundle = true;
      for (var i = 0; i < this.arrBundles.length; i++) {
        if (this.idBundlesEdit == this.arrBundles[i]._id) {
          this.arrBundles[i].groups.forEach((idgroup) => {
            this.arrayGroup.forEach((value) => {
              if (idgroup === value._id) {
                this.arrGroupTitle.push({
                  id: value._id,
                  title: value.title,
                });
              }
            });
          });

          this.title = this.arrBundles[i].title;
          this.price = this.arrBundles[i].price;
          this.description = this.arrBundles[i].description;
          this.imgPreview = this.arrBundles[i].images;
          if (this.imgPreview) {
            this.imageReady = true;
          }
          this.expireType = this.arrBundles[i].items[0].expireType;
          this.durationTypeDay = this.arrBundles[i].items[0].duration;
          this.selection = this.arrBundles[i].groups;
          this.selectStatus = this.arrBundles[i].active == true ? 1 : 2;
          if (this.arrBundles[i].groups.length == 0) {
            this.selectGroup = false; // all group
          } else {
            this.selectGroup = true; // only group
          }

          let y = new Date(this.arrBundles[i].startTime).getFullYear();
          let m = new Date(this.arrBundles[i].startTime).getMonth() + 1;
          let d = new Date(this.arrBundles[i].startTime).getDate();

          this.dateStart =
            y +
            '-' +
            m.toString().padStart(2, '0') +
            '-' +
            d.toString().padStart(2, '0');
          // this.dateStart = new Date(this.arrBundles[i].startTime).toISOString().substr(0, 10);

          y = new Date(this.arrBundles[i].endTime).getFullYear();
          m = new Date(this.arrBundles[i].endTime).getMonth() + 1;
          d = new Date(this.arrBundles[i].endTime).getDate();

          this.dateEnd =
            y +
            '-' +
            m.toString().padStart(2, '0') +
            '-' +
            d.toString().padStart(2, '0');

          // this.dateEnd = new Date(this.arrBundles[i].endTime)
          //   .toISOString()
          //   .substr(0, 10);

          if (this.arrBundles[i].items[0].expireDate == 0) {
            this.dateExp = new Date().toISOString().substr(0, 10);
          } else {
            // this.dateExp = new Date(this.arrBundles[i].items[0].expireDate).toDateString()
            let y = new Date(
              this.arrBundles[i].items[0].expireDate
            ).getFullYear();
            let m =
              new Date(this.arrBundles[i].items[0].expireDate).getMonth() + 1;
            let d = new Date(this.arrBundles[i].items[0].expireDate).getDate();

            this.dateExp =
              y +
              '-' +
              m.toString().padStart(2, '0') +
              '-' +
              d.toString().padStart(2, '0');
          }

          var hour_exp = new Date(this.arrBundles[i].items[0].expireDate)
            .toString()
            .substr(16, 2);
          var min_exp = new Date(this.arrBundles[i].items[0].expireDate)
            .toString()
            .substr(19, 2);

          var hour_start = new Date(this.arrBundles[i].startTime)
            .toString()
            .substr(16, 2);
          var min_start = new Date(this.arrBundles[i].startTime)
            .toString()
            .substr(19, 2);

          var hour_end = new Date(this.arrBundles[i].endTime)
            .toString()
            .substr(16, 2);
          var min_end = new Date(this.arrBundles[i].endTime)
            .toString()
            .substr(19, 2);

          this.hourExp = parseInt(hour_exp);
          this.minExp = parseInt(min_exp);
          this.hourStart = parseInt(hour_start);
          this.minStart = parseInt(min_start);
          this.hourEnd = parseInt(hour_end);
          this.minEnd = parseInt(min_end);
        }
      }
      if (this.expireType == 'duration') {
        this.selectDuration = 3;
      }
      if (this.expireType == 'duration' && this.durationTypeDay == 0) {
        this.selectDuration = 1;
      }
      if (this.expireType == 'expireDate') {
        this.selectDuration = 2;
      }

      // if (this.price == 0) {
      //   this.selectPrice = 1;
      // } else if (idcourse == null) {
      //   this.selectPrice = 1;
      // } else {
      //   this.selectPrice = 2;
      // }
    },
    async validate() {
      if (this.$refs.form.validate()) {
        let tempDateExp = this.dateExp;
        let date_exp = this.dateExp + ',' + this.hourExp + ':' + this.minExp;

        let date_start =
          this.dateStart + ',' + this.hourStart + ':' + this.minStart;
        let date_end = this.dateEnd + ',' + this.hourEnd + ':' + this.minEnd;

        let dt_exp = new Date(date_exp).toISOString();
        let dt_start = new Date(date_start).toISOString();
        let dt_end = new Date(date_end).toISOString();
        this.expTime = new Date(dt_exp).getTime();
        this.startTime = new Date(dt_start).getTime();
        this.endTime = new Date(dt_end).getTime();
        // if (this.selectPrice === 1) {
        //   this.price = 0;
        //   this.$refs.form.resetValidation();
        // }

        if (this.imageFile != null) {
          await this.uploadImg(this.imageFile);
        }

        if (this.selectDuration == 3) {
          this.typeExp = 'duration';
          this.expTime = 0;
        }
        if (this.selectDuration == 1) {
          this.typeExp = 'duration';
          this.durationTypeDay = 0;
          this.expTime = 0;
        }
        if (this.selectDuration == 2) {
          this.typeExp = 'expireDate';
          // this.dateExp = new Date().toISOString().substr(0, 10);
          this.durationTypeDay = 0;
        }

        if (this.idBundlesEdit) {
          if (this.selectDuration != 2) {
            if (
              this.startTime < this.endTime ||
              (this.selectGroup == true && this.selection.length > 0)
            ) {
              let resultBundles = await this.updateBundles();

              this.dialogUpdateSuccess = true;
              return resultBundles;
            } else {
              this.dialogWarning = true;
              this.dateExp = tempDateExp;
            }
          } else {
            if (
              //  this.startTime < this.dateExp > this.endTime &&

              this.expTime > this.startTime &&
              this.expTime > this.endTime &&
              this.startTime < this.endTime
            ) {
              let resultBundles = await this.updateBundles();

              this.dialogUpdateSuccess = true;
              return resultBundles;
            } else {
              // let tempDateExp = new Date(this.expTime).toISOString().substr(0, 10);
              // this.dateExp = tempDateExp;

              this.dialogWarning = true;
            }
          }
        } else {
          if (this.selectDuration != 2) {
            if (
              this.startTime < this.endTime ||
              (this.selectGroup == true && this.selection.length > 0)
            ) {
              let resultBundles = await this.insertBundles();

              this.dialogUpdateSuccess = true;
              return resultBundles;
            } else {
              this.dialogWarning = true;
              this.dateExp = tempDateExp;
            }
          } else {
            if (
              // this.startTime < this.dateExp > this.endTime &&
              (this.expTime > this.startTime &&
                this.expTime > this.endTime &&
                this.startTime < this.endTime) ||
              (this.selectGroup == true && this.selection.length > 0)
            ) {
              let resultBundles = await this.insertBundles();

              this.dialogUpdateSuccess = true;
              return resultBundles;
            } else {
              // let tempDateExp = new Date(this.expTime).toISOString().substr(0, 10);
              // this.dateExp = tempDateExp;
              this.dialogWarning = true;
              // this.dateExp = tempDateExp;
            }
          }
        }

        if (this.durationTypeDay >= 0) {
          this.$refs.form.resetValidation();
        }
      } else {
        console.log('not pass');
      }
      console.log(this.selectDuration);
    },
    async uploadImg(file) {
      this.showUploadPercent = true;

      let formData = new FormData();
      formData.append('fileupload', file);
      formData.append('title', file.name);
      await axios
        .post(`${domain}/uploadfile/public/image/bundle`, formData, {
          headers: {
            ...headersWithTokenForImage(),
          },
          onUploadProgress: function (progressEvent) {
            this.progressPercent = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
        .then(
          async function (response) {
            this.imgPreview = response.data.result;
          }.bind(this)
        )
        .catch(function (e) {
          console.log('FAILURE!!', e);
        });
    },
    async updateBundles() {
      await updateBundles({
        idbundles: this.idBundlesEdit,
        title: cleaningData(this.title),
        description: this.description,
        price: this.price,
        images: this.imgPreview,
        groups: this.selectGroup == true ? this.selection : [],
        items: [
          {
            course: this.params.idcourse,
            expireType: this.typeExp,
            duration: this.durationTypeDay,
            expireDate: this.expTime,
          },
        ],
        active: this.selectStatus == 1 ? true : false,
        starttime: this.startTime,
        endtime: this.endTime,
      });
    },
    async insertBundles() {
      await insertBundles({
        title: cleaningData(this.title),
        description: this.description,
        price: this.price,
        images: this.imgPreview,
        groups: this.selectGroup == true ? this.selection : [],
        items: [
          {
            course: this.params.idcourse,
            expireType: this.typeExp,
            duration: this.durationTypeDay,
            expireDate: this.expTime,
          },
        ],
        active: this.selectStatus == 1 ? true : false,
        starttime: this.startTime,
        endtime: this.endTime,
      });
    },
    async updatePricingOption() {
      let status = null;
      let valueData = {
        ...this.detail,
        id: this.$route.query.id,
        useBundle: this.bundleOption,
      };

      console.log(valueData);

      this.pricingOptionSuccess = false;
      this.pricingOptionFail = false;
      this.pricingOptionSaving = true;

      status = await updateCourse(valueData);

      this.pricingOptionSaving = false;

      if (status.code == 403) {
        this.pricingOptionFail = true;
        return 403;
      } else {
        this.pricingOptionSuccess = true;
        return status.code;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}

.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}
.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  background: none;
}
.text-field-border {
  border: 1px solid;
  border-radius: 8px;
  border-color: rgba(65, 65, 65, 0.3);
  height: 40px;
}
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.md-fixed-max-width {
  max-width: 250px;
}
.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}
.rounded-card {
  border-radius: 8px;
}
.a-disabled {
  pointer-events: none;
  color: #ccc;
}
.img-panel {
  width: 100%;
  height: 120px;
  border: 2px dashed #b9b9b9;
  background: rgba(0, 0, 0, 0.02);
}
.action {
  &:hover {
    text-decoration: underline;
  }
}
.search-input > .v-text-field.v-text-field--enclosed .v-text-field__details,
.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  /* padding: 0 12px; */
  min-height: 40px;
}
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  height: 42px;
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 41px;
  text-transform: unset;
  font-weight: normal;
}
.title-live {
  text-transform: uppercase;
}
.v-btn:not(.v-btn--round).v-size--default {
  text-transform: unset;
}
.text-uppercase {
  text-transform: uppercase;
}
.btn-reload {
  background: #ffffff !important;
  border: 1px solid #d9d9d9;
  color: rgb(77, 77, 77);
  box-shadow: none !important;
}
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 170px !important;
}

.btn-choose {
  color: rgba(0, 0, 0, 0.65);
  background-color: white;
  padding: 8px 20px;
  font-size: 16px;
  width: 170px !important;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
}

.upload-btn-wrapper input[type='file'] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}

.upload-btn-wrapper input[type='file']:hover {
  cursor: pointer;
}
</style>
